import React, { useState, useEffect, Component, useRef } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { cloneDeep } from "lodash";

import CloseModal from "../../../Components/CloseModal";
import {
  formatIndianCurrency,
  replaceComma,
  checkIfNotDecimal,
} from "../../../Utils/helperFunctions";
import {
  getBranches,
  uploadbulkspoke,
  uploadbulkspokeMapping,
} from "../../../Utils/Services/spokeMaster";

toast.configure();

const BulkUploadSpokeMapping = (props) => {
  const [showModal, setshowModal] = useState(true);
  const [loading, setLoading] = useState("selecting");
  const [showInner, setshowInner] = useState(false);
  const [file, setFile] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const [branchOptions, setBranchOptions] = useState([]);

  const BulkUploader = useRef(null);

  useEffect(() => {
    getBranches().then((branches) => {
      const formatted = branches.map((b) => ({
        value: b.branchCode || b.id,
        label: b.branchName,
      }));
      setBranchOptions(formatted);
    });
  }, []);

  const handleModalClose = () => {
    setshowInner(!showInner);
  };

  const innerModalClose = (modclose) => {
    if (!modclose) {
      handleModalClose();
    }
    setshowModal(false);
    props.handleBulkUpload();
  };

  const handleInputClick = () => {
    if (loading === "selecting") {
      BulkUploader.current.click();
    }
  };
  const handleSelectFile = (e) => {
    setFile(e.target.files[0]);
  };

  const convertBase64ToBlob = (base64, mimeType) => {
    const byteArray = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    return new Blob([byteArray], { type: mimeType });
  };

  const handleUpload = () => {
    if (!selectedBranch?.value) {
      toast.error("Please select a branch before uploading");
      return;
    }
    const maxSizeInBytes = 10 * 1024 * 1024;
    const fileType = file.name.split(".").pop().toLowerCase();

    if (file.size > maxSizeInBytes) {
      toast.error("File size should not exceed 10 MB");
      return props.handleBulkUpload();
    }

    if (fileType !== "csv") {
      toast.error(`${fileType} extension is invalid`);
      return props.handleBulkUpload();
    }

    setLoading("uploading");

    const formData = new FormData();
    formData.append(
      "file",
      new Blob([file], { type: "text/csv" }),
      `upload.${fileType}`
    );

    uploadbulkspokeMapping(formData, selectedBranch?.value)
      .then((res) => {
        toast[res?.status === "success" ? "success" : "error"](
          res?.message || "Upload completed"
        );

        if (res?.result?.file) {
          const blob = convertBase64ToBlob(
            res.result.file,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "response_file.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        }
      })
      .catch(() => toast.error("Unexpected error"))
      .finally(() => props.handleBulkUpload());
  };

  return (
    <React.Fragment>
      <Modal
        className="bulk-upload-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Bulk Spoke Mapping</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div
            style={{ display: "flex", gap: "2rem", alignItems: "flex-start" }}
          >
            <div style={{ flex: 1 }}>
              <label
                style={{
                  fontWeight: "bold",
                  marginBottom: "8px",
                  display: "block",
                }}
              >
                Select Branch
              </label>
              <Select
                options={branchOptions}
                value={selectedBranch}
                onChange={setSelectedBranch}
                placeholder="Choose branch..."
              />
            </div>
            <div
              className="bulk-upload-input-div"
              onClick={handleInputClick}
              style={{ flex: 1, textAlign: "center" }}
            >
              {loading === "selecting" && (
                <>
                  <input
                    type="file"
                    name="BulkleadUpload"
                    id="file"
                    ref={BulkUploader}
                    onChange={handleSelectFile}
                    style={{ display: "none" }}
                  />
                  <i
                    className="fas fa-upload fa-4x"
                    name="BulkleadUpload"
                    style={{
                      color: "#1e1f63",
                      cursor: "pointer",
                      marginBottom: "20px",
                    }}
                  ></i>
                  <p>{file ? file.name : "Select File"}</p>
                </>
              )}
              {loading === "uploading" && (
                <>
                  <i className="fa fa-spinner fa-spin fa-4x"></i>
                  <p>Uploading...</p>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-danger" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button
            className="btn-success"
            disabled={!file}
            onClick={handleUpload}
          >
            Upload
          </Button>
        </Modal.Footer>
      </Modal>
      <CloseModal
        show={showInner}
        button2={handleModalClose}
        button1={innerModalClose}
        title="Do you want to close ?"
      />
    </React.Fragment>
  );
};

export default BulkUploadSpokeMapping;
